(ns app.components.workspace-item.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))

(defclass selected-divider
  []
  {:border-radius "4px"
   :height "40px"
   :background-color :theme/*purpleHover*})

(defclass new-workspace-item
  []
  {:background-color "transparent"
   :font-size "18px"
   :font-weight "600"
   :border "none"
   :border-radius "4px"
   :width "40px"
   :height "40px"}
  [:&:hover
   {:outline-width "2px"
    :outline-color :theme/*purple100*
    :background-color :theme/*purpleHoverSecondary*
    :font-size "18px"
    :font-weight "600"
    :border-radius "4px"
    :width "40px"
    :height "40px"
    :color :theme/*purple500*}])
(defclass workspace-item
  []
  {:background-color :theme/*purpleHoverSecondary*
   :font-size "18px"
   :font-weight "600"
   :border "none"
   :border-radius "4px"
   :width "40px"
   :height "40px"}
  [:&:hover
   {:outline "thick solid"
    :outline-width "2px"
    :outline-color :theme/*purple100*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*purpleHover*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*purpleHover*
    :outline "none"}])

(defclass selected-workspace-item
  []
  {:font-size "18px"
   :font-weight "600"
   :width "40px"
   :height "40px"
   :color "white"
   :border "none"
   :border-radius "4px"
   :background-color  :theme/*purpleHover*
   :outline "none"}
  [:&:hover
   {:color "white"
    :outline "thick solid"
    :outline-width "2px"
    :outline-color :theme/*purple100*}]
  [:&:focus
   {:color "white"
    :background-color  :theme/*purpleHover*
    :outline "none"}]
  [:&:active
   {:color "white"
    :background-color  :theme/*purpleHover*
    :outline "none"}])

(defclass workspace-tooltip
  []
  {:color "white"}
  [:.MuiTooltip-tooltip {:background-color :theme/*dark21*
                         :font-size "14px"
                         :opacity "0.85 !important"
                         :padding "7px"}]
  [:.MuiTooltip-arrow {:color :theme/*dark21*}])
